$(document).ready(function() {
	'use strict';


	/**
	 * Adds error message to the queue.
	 */
	Nette.addError = function(elem, message) {
		var $formElement = $(elem);

		if ($formElement.attr('type') === 'radio') {
			$formElement = $('input[name="' + $formElement.attr('name') + '"]:not(:disabled)').first();
		}

		$formElement.data('error-message',message);

		Nette.formErrors.push({
			element: elem,
			message: message
		});
	};


	/**
	 * Display error messages.
	 */
	Nette.showFormErrors = function(form, errors) {
		if (errors.length === 0) {
			return;
		}

		var $formElement = $(errors[0].element);

		if ($formElement.attr('type') === 'radio') {
			$formElement = $('input[name="' + $formElement.attr('name') + '"]:not(:disabled)').first();
		}

		$formElement.data('error-message', errors[0].message).focus();
		$.flashMessenger.createFlashMessage(errors[0].message,'error',5000);
	};

});